export async function useFetchWithFiles(url, data, method = 'POST') {
  const formData = new FormData();
  const serverUrl = import.meta.env.VITE_API_SERVER

  for (const key in data) {
    formData.append(key, data[key]);
  }

  const requestOptions = {
    method: method,
    credentials: 'include',
    redirect: 'follow'
  }

  if(Object.keys(data).length > 0) {
    requestOptions.body = formData
  }

  const response = await fetch(serverUrl + url, requestOptions);

  if (response.ok) {
    const responseData = await response.json();
    return { data: responseData, success: true };
  } else {
    const errorData = await response.text();
    throw new Error(`Error en la solicitud: ${response.status} - ${errorData}`);
  }
}
